import React from "react";

/**
 * Minimal skeleton shimmer used across Winners Wall, Drops list, City page.
 * Keep it free of external deps — CSS-only shimmer via @keyframes in index.css.
 */
export function Skeleton({ className = "", style = {} }) {
  return (
    <div
      className={`loot-skeleton ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="loot-card p-5 flex flex-col gap-3">
      <Skeleton className="h-4 w-16" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-6 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  );
}

export function SkeletonGrid({ count = 6 }) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="skeleton-grid">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
